import { render } from "./NotifikacieZvoncek.vue?vue&type=template&id=864e7b72&scoped=true"
import script from "./NotifikacieZvoncek.vue?vue&type=script&lang=js"
export * from "./NotifikacieZvoncek.vue?vue&type=script&lang=js"

import "./NotifikacieZvoncek.vue?vue&type=style&index=0&id=864e7b72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-864e7b72"]])

export default __exports__